import { getI18nLocale } from '@wecasa/i18n';

import { getIntlInstance } from './intl';

export const formatFloatNumber = (number: number) => getIntlInstance(Intl.NumberFormat, getI18nLocale()).format(number);

export const parseIntNumber = (numberStr: string) => (numberStr ? parseInt(numberStr, 10) : null);
